import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, Grid } from '@material-ui/core'

import { ImpersonationBar } from './ImpersonationBar'
import { MoySkladStatusMapPanel } from './MoySkladStatusMapPanel'
import { MoySkladNamePhoneFormPanel } from './MoySkladNamePhoneFormPanel'
import { OnboardingScreen } from './OnboardingScreen'

import { useStore } from '../hooks/storeHook'
import { useBoolState } from '../hooks/commonHooks'

import { required } from '../common/objectUtils'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { isAppTypeMpSklad } from '../common/isAppTypeMpSklad'
import { isAppTypeMpCard } from '../common/isAppTypeMpCard'
import { MoySkladAppState } from '../server/mpsklad_core/Models/MoySkladAppState'

export const MoySkladAppSettingsScreen =
  observer(
    () => {
      const classes = useStyles()
      const store = useStore()
      const user = required(store.user)
      const [hasPersonalData, setHasPersonalData] = useBoolState()
      const isMpSklad = isAppTypeMpSklad()
      const isMpCard = isAppTypeMpCard()
      const showOnboarding = isMpCard && !user.onboardingCompleted
      const step = (!hasPersonalData && !user.phoneNumber) || !isMpSklad ? 1 : 2

      const handleFinish = () => {
        setHasPersonalData()

        if (!isMpSklad) {
          user.moySkladAppState = MoySkladAppState.Active
        }
      }

      if (showOnboarding) {
        return (
          <div className="body_wrapper_zero">
            <ImpersonationBar/>
            <OnboardingScreen onFinish={handleFinish}/>
          </div>
        )
      }

      return (
        <div className="body_wrapper_zero">
          <ImpersonationBar/>

          <Box padding={3}
               style={{
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'center',
                 justifyContent: 'center'
               }}>
            <h1 style={{textTransform: 'uppercase'}}>
              {isMpSklad && <span className={classes.stepLabel}>Шаг {step}/2</span>} Настройка приложения
            </h1>

            <Grid container spacing={3} alignItems="center" justifyContent="center">
              <Grid item lg={6} xl={4} xs={6}>
                <Grid container direction="column" spacing={3}>
                  {step === 1 ?
                   <Grid item lg={12} xs={10}>
                     <MoySkladNamePhoneFormPanel onFinish={handleFinish}/>
                   </Grid> :
                   isMpSklad ? (
                     <Grid item lg={12}>
                       <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                         <MoySkladStatusMapPanel shouldSkipMapButton shouldShowHelpHints/>
                       </Box>
                     </Grid>
                   ) : null
                  }
                </Grid>
              </Grid>

            </Grid>
          </Box>
        </div>
      )
    })

const useStyles =
  makeStyles(() =>
    createStyles({
      stepLabel: {
        color: '#F19F94'
      }
    }))
